/**
 * The spreadsheet import contract.
 *
 * The browser reads the file - it already has every parser, and a 20 MB
 * workbook is better opened next to the person who chose it than uploaded and
 * parsed blind. What it sends is rows, already mapped to fields. The server
 * decides what those rows mean for the catalog and writes them in one
 * transaction, so "imported" is the server's word, never the browser's.
 *
 * Photos travel separately, one request per picture, after the rows are in.
 * Inside the rows they made a single request too big to ever arrive.
 */
/**
 * A mould number that says there is no mould number.
 *
 * The client's sheets write "NA" where a mould has not been numbered yet -
 * seventeen times in the Kandivali sheet alone. Taken as a code, the first
 * became a mould called NA and the rest looked like its duplicates. These are
 * reported as needing a number, never imported.
 */
export function isPlaceholderCode(code) {
    return /^(N\/?A|N\.A\.?|NIL|NONE|NULL|TBD|TBA|-+|\.+|0+|X+|\?+)$/i.test(code.trim());
}
/** Master-valued columns, by the field name the importer maps them to. */
export const IMPORT_MASTER_FIELDS = [
    'project',
    'ownerCompany',
    'customer',
    'manufactureCompany',
    'designer',
    'toolType',
    'runnerType',
    'gateType',
    'ejectionType',
    'mechanismType',
    'coreCavityMaterial',
    'moldBaseMaterial',
    'materialGrade',
];
/**
 * Mould fields a spreadsheet can fill - and a person can fill by hand.
 *
 * Excel is where a mould's details usually start; it is not the only place.
 * When someone sets one of these on the form, the server notes it in
 * `Mould.manualFields`, and a later import keeps that value: a new sheet value
 * replaces one that came from a sheet, never one a person typed, unless the
 * person importing chooses "replace values". A blank cell never clears anything.
 */
export const IMPORTABLE_MOULD_FIELDS = [
    'name',
    'description',
    'cavities',
    'moldSize',
    'manufactureYear',
    'qrNumber',
    'toolTransfer',
    'projectId',
    'ownerCompanyId',
    'customerCompanyId',
    'manufactureCompanyId',
    'designerId',
    'toolTypeId',
    'runnerTypeId',
    'gateTypeId',
    'ejectionTypeId',
    'coreCavityMaterialId',
    'moldBaseMaterialId',
    'materialGradeId',
    'mechanismTypeId',
];
//# sourceMappingURL=imports.js.map